export default {
  _s3getSiteBucketUrl() {
    const bucket = process.env.S3_WEBSITE_BUCKET;
    const region = process.env.S3_REGION;
    return `https://${bucket}.s3-${region}.amazonaws.com/`;
  },
  _s3deleteFile(p) {
    return this._SEND([{
      name: 'deleteUserFile',
      payload: {
        file: p.key,
        siteId: this._currentSite._id,
      },
    }]);
  },
  _s3emptyFolder(p) {
    return this._SEND([{
      name: 'emptyEntireFolder',
      payload: {
        path: p.path,
        siteId: this._currentSite._id,
      },
    }]);
  },
  _s3fetchFiles(path) {
    const folder = path || '';
    return this._SEND([{
      name: 'fetchUserFiles',
      payload: { folder },
    }]);
  },
  _s3checkFile(p) {
    return this._SEND([{
      name: 'checkUserFile',
      payload: {
        file: p.path,
      },
    }]);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/aws/s3.js